module.exports = __webpack_public_path__ + "img/general-infos-active.811fa17f.svg";